import React from 'react';
import { useHistory } from "react-router-dom";
import ReactGA from "react-ga";

import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import LaunchIcon from "@material-ui/icons/Launch";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import CompanyImg from "../Pages/CompanyDetail/CompanyImg";

import theme from "../Theme";

const tableStyles = makeStyles( theme => ({
    tableRow: {
        '&:hover': {
          backgroundColor: "#1a73e842 !important",
        }
    }    
}));

const tableFields = [
    "name",
    "status",
    "remoteSince",
    "remoteUntil",
    "hq",
    "numEmployees",
    "jobsLink",
    "source",
];

function logAnalyticsEvent({ category, action, label }) {
    if (
      window.location.hostname !== "localhost" &&
      window.location.hostname !== "127.0.0.1"
    ) {
      ReactGA.event({
        category,
        action,
        label,
      });
    }
  }
function goToJobsPage(companyName) {
    logAnalyticsEvent({
      category: "Jobs Link",
      action: "Jobs Link Clicked",
      label: `Main Table for ${companyName}`,
    });
  }

  function goToSourcePage(companyName) {
    logAnalyticsEvent({
      category: "Source Link",
      action: "Source Link Clicked",
      label: `Main Table for ${companyName}`,
    });
  }

export default function StatusTableRow({ row }) {
    let history = useHistory();
    const classes = tableStyles();

    const goToDetailPage = (name) => () => history.push(`/company/${name}`);

    const fields = [];

    const renderTableRow = (row, goToDetailPage) => {
        tableFields.forEach((field, idx) => {
          const align = idx === tableFields.length - 1 ? "right" : "left";
          let clickHandler;
      
          if (field !== "source" && field !== "jobsLink") {
            clickHandler = goToDetailPage;
          }
      
          // No longer displaying these fields
          if (field === "remoteSince" || field === "remoteUntil") {
            return;
          }
      
          if (field === "name") {
            fields.push(
              <TableCell
                component="th"
                align={align}
                id={field}
                key={`${field}-${row.name}`}
                scope="row"
                component="a"
                className={classes.companyName}
                onClick={clickHandler}
              >
                {row.logo ? (
                  <CompanyImg
                    imgSrc={row.logo}
                    style={{
                      width: "20px",
                      height: "20px",
                      marginTop: "0px",
                      marginBottom: -4,
                      marginRight: 8,
                      borderRadius: 3,
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      marginTop: "0px",
                      marginBottom: -4,
                      marginRight: 8,
                      borderRadius: 3,
                      backgroundColor: theme.palette.primary.light,
                      display: "inline-block",
                    }}
                  ></div>
                )}
                {row[field] || field}
                <LaunchIcon
                  style={{
                    backgroundColor: "white",
                    padding: 0,
                    marginLeft: "4px",
                    position: "relative",
                    bottom: "-2px",
                    fontSize: "14px",
                    color: "#3470eb",
                  }}
                />
              </TableCell>
            );
          } else if (field === "numEmployees") {
            let rowText = "";
            if (row[field]) {
              let number = Number(parseFloat(row[field].replace(/,/g, "")));
              if (number < 10) {
                rowText = "<10";
              } else {
                number =
                  number > 100 ? number - (number % 100) : number - (number % 10);
                rowText = `~${new Intl.NumberFormat("en-US").format(number)}`;
              }
            } else {
              rowText = "Not Available";
            }
            fields.push(
              <TableCell
                component="th"
                align={align}
                id={field}
                key={`${field}-${row.name}`}
                scope="row"
                component="a"
                className={classes.companyName}
                onClick={clickHandler}
              >
                {rowText}
              </TableCell>
            );
          } else if (field === "jobsLink") {
            fields.push(
              <TableCell
                component="th"
                align={align}
                id={field}
                key={`${field}-${row.name}`}
                scope="row"
                component="a"
                className={classes.companyName}
                onClick={() => goToJobsPage(row.name)}
              >
                {row[field] || "Not Available"}
              </TableCell>
            );
          } else if (field === "source") {
            fields.push(
              <TableCell
                component="th"
                align={align}
                id={field}
                key={`${field}-${row.name}`}
                scope="row"
                component="a"
                className={classes.companyName}
                onClick={() => goToSourcePage(row.name)}
              >
                {row[field] || field}
              </TableCell>
            );
          } else if (field === "status") {
            let remoteText = "";
            if (row.remoteSince === "Always") {
              remoteText = "(Always)";
            } else {
              remoteText = `(${
                row.remoteSince === "-" ? "" : `${row.remoteSince} `
              }${
                row.remoteUntil === "-" ? "onwards" : `until ${row.remoteUntil}`
              })`;
            }
            fields.push(
              <TableCell
                component="th"
                align={align}
                id={field}
                key={`${field}-${row.name}`}
                scope="row"
                component="a"
                className={classes.companyName}
                onClick={clickHandler}
              >
                {row[field] || field}
                <Typography
                  variant="body2"
                  align="left"
                  style={{
                    fontStyle: "italic",
                    fontSize: "0.75rem",
                    color: "gray",
                  }}
                >
                  {remoteText}
                </Typography>
              </TableCell>
            );
          } else if (field === "hq") {
            fields.push(
              <TableCell
                component="th"
                align={align}
                id={field}
                key={`${field}-${row.name}`}
                scope="row"
                component="a"
                className={classes.companyName}
                onClick={clickHandler}
              >
                {row[field] || "Not Available"}
              </TableCell>
            );
          } else {
            fields.push(
              <TableCell
                component="th"
                align={align}
                id={field}
                key={`${field}-${row.name}`}
                scope="row"
                component="a"
                className={classes.companyName}
                onClick={clickHandler}
              >
                {row[field] || field}
              </TableCell>
            );
          }
        });
      
        return fields;
      };


    return (
        <TableRow
          hover
          tabIndex={-1}
          keys={row.name}
          key={row.name}
          className={classes.tableRow}
          style={{ cursor: "pointer" }}
        >
          {renderTableRow(row, goToDetailPage(row.name))}
        </TableRow>        
    )
}
